import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";

export async function printCustomerInvoice(payload) {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const url = `https://${subdomain}.restocash.app/api/print/customer/invoice?api_password=Project102$_`;

  console.log("Sending print payload:", payload);

  const res = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload), // 👈 ابعت كل البيانات
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "فشل في طباعة الفاتورة للعميل");
  return data;
}
